import { render, staticRenderFns } from "./_EmentaAssuntoCadastro.vue?vue&type=template&id=99892dd0&scoped=true"
import script from "./_EmentaAssuntoCadastro.vue?vue&type=script&lang=ts"
export * from "./_EmentaAssuntoCadastro.vue?vue&type=script&lang=ts"
import style0 from "./_EmentaAssuntoCadastro.vue?vue&type=style&index=0&id=99892dd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99892dd0",
  null
  
)

export default component.exports